import { CustomSpacingEditorModal } from "./custom-spacing-editor-modal/custom-spacing-editor-modal";
import { DEFAULTS } from "./defaults";
import { getTextButtons } from "./getTextButtons";
import { InsertDecorationModal } from "./insert-decoration-modal/insert-decoration-modal";
import { lineSpacing } from "./tiptap";
import { LINE_SPACING_TYPE } from "./types";
const pluginLineSpacing = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINE_SPACING_TYPE,
    textButtons: getTextButtons(),
    tiptapExtensions: [lineSpacing],
    __exports: {
      InsertModal: InsertDecorationModal,
      CustomSpacingEditorModal
    }
  };
};
export {
  pluginLineSpacing
};
//# sourceMappingURL=editor.js.map
